import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/tokens.css'
import './styles/components.css'
import './styles/app.css'
import './styles/design-overrides.css'
import App, { PublicLeaderboard } from './App.jsx'

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { err: null, info: null } }
  static getDerivedStateFromError(err) { return { err } }
  componentDidCatch(err, info) {
    console.error('App crashed:', err, info)
    this.setState({ info })
  }
  render() {
    if (this.state.err) {
      const err = this.state.err
      const msg = err?.message || String(err)
      const stack = err?.stack || ''
      const componentStack = this.state.info?.componentStack || ''
      return React.createElement('div', {
        style: {
          padding:40, fontFamily:'-apple-system,sans-serif', maxWidth:800, margin:'40px auto',
          background:'#fff', color:'#111', borderRadius:14, border:'1px solid #eee'
        }
      },
        React.createElement('h2', { style:{color:'#E03131', marginBottom:12} }, 'WorkBro hit an error'),
        React.createElement('p', { style:{color:'#555', marginBottom:16, lineHeight:1.6} },
          'Try a hard refresh (Cmd/Ctrl+Shift+R) or click the button below to clear local data and reload. If it happens again, copy the details below and send to support.'),

        React.createElement('div', { style: { marginBottom: 14 } },
          React.createElement('div', { style:{fontSize:11, color:'#888', textTransform:'uppercase', fontWeight:700, marginBottom:6}}, 'Error Message'),
          React.createElement('div', { style:{background:'#fff3f3', padding:12, borderRadius:6, fontFamily:'monospace', fontSize:13, color:'#b00', border:'1px solid #ffcccc'}}, msg)
        ),

        componentStack && React.createElement('div', { style: { marginBottom: 14 } },
          React.createElement('div', { style:{fontSize:11, color:'#888', textTransform:'uppercase', fontWeight:700, marginBottom:6}}, 'Component Stack'),
          React.createElement('pre', {
            style: { background:'#f7f7f8', padding:12, borderRadius:6, fontSize:11, color:'#333', overflow:'auto', maxHeight:200, border:'1px solid #eee', margin:0, whiteSpace:'pre-wrap' }
          }, componentStack.trim())
        ),

        React.createElement('details', { style: { marginBottom: 14 } },
          React.createElement('summary', { style: { cursor:'pointer', fontSize:12, color:'#555' } }, 'Technical stack trace'),
          React.createElement('pre', {
            style: { background:'#f7f7f8', padding:12, borderRadius:6, fontSize:11, color:'#b00', overflow:'auto', maxHeight:200, border:'1px solid #eee', marginTop:8, whiteSpace:'pre-wrap' }
          }, stack)
        ),

        React.createElement('div', { style: { display:'flex', gap:8, flexWrap:'wrap' } },
          React.createElement('button', {
            onClick: () => { location.reload() },
            style: { padding:'10px 20px', background:'#fff', color:'#333', border:'1px solid #ddd', borderRadius:6, fontWeight:600, cursor:'pointer' }
          }, 'Reload page'),
          React.createElement('button', {
            onClick: () => { localStorage.clear(); sessionStorage.clear(); location.reload() },
            style: { padding:'10px 20px', background:'#c96a33', color:'#fff', border:'none', borderRadius:8, fontWeight:600, cursor:'pointer' }
          }, 'Clear local data and reload')
        )
      )
    }
    return this.props.children
  }
}

// Public leaderboard link — render standalone, bypass the full app (no login/session/routing)
const wcParam = new URLSearchParams(window.location.search).get('wc')
const isPublicLeaderboard = wcParam && wcParam.includes(':')

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      {isPublicLeaderboard
        ? <PublicLeaderboard companyId={wcParam.split(':')[0]} eventId={wcParam.split(':')[1]} />
        : <App />}
    </ErrorBoundary>
  </React.StrictMode>,
)
